export default "__VITE_ASSET__Bbmtrb1T__"